import type { Problem, ProblemCode } from "@shared/contracts";

export type ApiFailure = ProblemCode | "network" | "unexpected_response";

/** Anything that can go wrong calling the API, in a form a page can explain to a person. */
export class ApiError extends Error {
  readonly failure: ApiFailure;
  readonly fields: Record<string, string[]>;

  constructor(failure: ApiFailure, message: string, fields: Record<string, string[]> = {}) {
    super(message);
    this.name = "ApiError";
    this.failure = failure;
    this.fields = fields;
  }

  static fromProblem(problem: Problem): ApiError {
    return new ApiError(problem.error.code, problem.error.message, problem.error.fields ?? {});
  }
}
